export default {
  otherInformationLabel: 'Other Information',
  ctaOpenLabel: 'View Less',
  ctaCloseLabel: 'View More',
  luxeCtaOpenLabel: '- Less',
  luxeCtaCloseLabel: '+ More',
  sneakerhoodCtaOpenLabel: 'Less details',
  sneakerhoodCtaCloseLabel: 'More details',
  luxeSneakerhoodCtaOpenLabel: '- Less details',
  luxeSneakerhoodCtaCloseLabel: '+ More details',
  sneakerHoodDefaultLength: 8,
  sneakerHoodMaxLength: 20
};
